// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___4t8y","col":"styles_col__EMQzp"};